// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__LHNy4","sorted":"table_sorted__3vnPe","shortText":"table_shortText__1wDH9"};